import React, { useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export default function EmailSettings() {
  const [bcc, setBcc] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const fn = httpsCallable(functions, "initUserBcc");
      const res = await fn();
      setBcc(res.data.bcc_email);
      setLoading(false);
    };
    load();
  }, []);

  const copy = async () => {
    await navigator.clipboard.writeText(bcc);
    alert("BCC email copied");
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div style={{ padding: 30 }}>
      <h2>Email Capture (BCC)</h2>

      <p>Your personal LogitOnce BCC address:</p>

      <code style={{ display: "block", padding: 12 }}>
        {bcc}
      </code>

      <button onClick={copy}>Copy</button>

      <p style={{ marginTop: 10, opacity: 0.7 }}>
        Copy once. Your email app will remember it.
      </p>
    </div>
  );
}
